import { render, staticRenderFns } from "./loginpanel.vue?vue&type=template&id=640ef567&scoped=true&"
import script from "./loginpanel.vue?vue&type=script&lang=js&"
export * from "./loginpanel.vue?vue&type=script&lang=js&"
import style0 from "./loginpanel.vue?vue&type=style&index=0&id=640ef567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ef567",
  null
  
)

export default component.exports